import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import { USER_TRANSACTIONS } from '../../../../pages/constants';
import FastCashPresenter from '../../../../presenters/FastCashPresenter';
import IntegrationItemPresenter from '../../../../presenters/FastCash/IntegrationItemPresenter';
import BankAccountPresenter from '../../../../presenters/BankAccountPresenter';
import Lists from '../../../../components/FastCash/Lists';
import ReportData from '../../../../components/FastCash/ReportData';
import { ErrorFlash } from '../../../../components';
import { deleteCashback } from '../../../../mutations';

import FastCashInfo from './components/FastCashInfo';
import IntegrationItem from './components/IntegrationItem';
import ReferralInfo from './components/ReferralInfo';
import CashbackInfo from './components/CashbackInfo';

const FastCashContent = (props) => {
  const {
    relay,
    fastCash,
    lists,
    onFetchTransactions,
    onPlaidDialogOpen,
    searchParams,
    onSearchParamsChange,
    stores,
    isFlagUser,
    handleFlagUser,
    handleUnFlagUser,
    specialCashbackRates,
  } = props;
  const transactions = lists.plaidTransactions.edges.map((e) => e.node);
  const { cashbacks, bankAccounts, checkIns } = fastCash;
  const { afterDate, beforeDate } = searchParams;

  const bankAccountsInfo = bankAccounts.map((bankAccount) => {
    const integrationItem = BankAccountPresenter.integrationItem(bankAccount);

    return {
      id: BankAccountPresenter.id(bankAccount),
      name: BankAccountPresenter.name(bankAccount),
      plaidAccountId: BankAccountPresenter.plaidAccountId(bankAccount),
      institutionName:
        IntegrationItemPresenter.institutionName(integrationItem),
    };
  });

  const user = FastCashPresenter.user(fastCash);

  const [errors, setErrors] = useState(null);

  const handleDeleteConfirm = (cashbackId) => {
    const params = { ...searchParams, cashbackId };

    deleteCashback(relay.environment, params, lists.id, {
      onCompleted: (response) => handleDeleteSuccess(response),
      onError: (error) => setErrors(error.message),
    });
  };

  const handleDeleteSuccess = (response) => {
    const { errorMessage } = response.deleteCashback;
    if (!isNil(errorMessage)) return setErrors(errorMessage);

    window.alert('FastCash removed');
  };

  const integrationItems = FastCashPresenter.integrationItems(fastCash);
  const transactionsData = FastCashPresenter.transactionsData(fastCash);
  const { transactionsCount } = transactionsData;

  return (
    <div>
      <CashbackInfo
        fastCash={fastCash}
        isFlagUser={isFlagUser}
        handleFlagUser={handleFlagUser}
        handleUnFlagUser={handleUnFlagUser}
        specialCashbackRates={specialCashbackRates}
      />
      <FastCashInfo fastCash={fastCash} user={user} checkIns={checkIns} />
      <ReferralInfo user={user} />
      {!isNil(errors) && <ErrorFlash errors={errors} message={errors} />}
      {integrationItems.map((item) => (
        <IntegrationItem
          key={IntegrationItemPresenter.id(item)}
          item={item}
          relay={relay}
          onFetchTransactions={onFetchTransactions}
          onPlaidDialogOpen={onPlaidDialogOpen}
          searchParams={searchParams}
        />
      ))}
      <ReportData
        transactionsData={transactionsData}
        cashbacksData={FastCashPresenter.cashbacksData(fastCash)}
        startDate={afterDate}
        endDate={beforeDate}
      />
      <Lists
        transactions={transactions}
        transactionsCount={transactionsCount}
        cashbacks={cashbacks}
        bankAccounts={bankAccounts}
        bankAccountsInfo={bankAccountsInfo}
        integrationItemsInfo={integrationItems}
        fastCashId={FastCashPresenter.id(fastCash)}
        onDeleteCashback={handleDeleteConfirm}
        relay={relay}
        pageType={USER_TRANSACTIONS}
        lists={lists}
        searchParams={searchParams}
        onSearchParamsChange={onSearchParamsChange}
        stores={stores}
      />
    </div>
  );
};

FastCashContent.propTypes = {
  relay: PropTypes.shape().isRequired,
  fastCash: FastCashPresenter.shape().isRequired,
  lists: PropTypes.shape().isRequired,
  onFetchTransactions: PropTypes.func.isRequired,
  onPlaidDialogOpen: PropTypes.func.isRequired,
  searchParams: PropTypes.shape().isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
};

export default FastCashContent;
